{
  "version": 1,
  "source": "docs/reference/painting-1538-amsterdam-museum.jpg",
  "sourceSize": [6692, 4866],
  "notes": "Thirteen distinguishable canal-front roof masses south of the Oude Kerk. Picks and order are observations; correspondence to retained lane intervals, widths, storeys, hidden depths and oblique plot axis are estimates, not a recovered parcel survey. Twelve ordinary-looking masses now use 24 explicit narrower inferred properties to avoid the oversized gables produced by one-mass/one-house allocation. Their shared source pixel identifies the parent mass, not additional observed houses. The wide slate mass between Gooijersteeg and Blaauwlakensteeg remains one unidentified provisional body with unresolved parcel interpretation; no guessed ordinary-house subdivision is imposed on it. It retains its original style key. Rear margins and the church-side open ground remain protected. Inner district buildings remain for later passes. See docs/oudezijde-blocks.md, Canal fronts south of the Oude Kerk.",
  "rows": [
    {
      "id": "oudekerk-south-canal",
      "source": "quay-oudezijds-voorburgwal-2",
      "side": "left",
      "from": 266,
      "to": 416,
      "depth": 28,
      "shear": -0.22,
      "evidence": "painted",
      "houses": [
        {
          "id": "oudekerk-south-canal-01",
          "widthWeight": 1.0,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2515, 2449],
          "plots": [
            {
              "id": "oudekerk-south-canal-01/a",
              "widthWeight": 1,
              "ordinal": 50
            },
            {
              "id": "oudekerk-south-canal-01/b",
              "widthWeight": 1,
              "ordinal": 51
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-02",
          "widthWeight": 1.0,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2546, 2484],
          "plots": [
            {
              "id": "oudekerk-south-canal-02/a",
              "widthWeight": 1,
              "ordinal": 52
            },
            {
              "id": "oudekerk-south-canal-02/b",
              "widthWeight": 1,
              "ordinal": 53
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-03",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2570, 2506],
          "plots": [
            {
              "id": "oudekerk-south-canal-03/a",
              "widthWeight": 1,
              "ordinal": 54
            },
            {
              "id": "oudekerk-south-canal-03/b",
              "widthWeight": 1,
              "ordinal": 55
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-04",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2587, 2540]
        },
        {
          "id": "oudekerk-south-canal-05",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2597, 2562],
          "plots": [
            {
              "id": "oudekerk-south-canal-05/a",
              "widthWeight": 1,
              "ordinal": 58
            },
            {
              "id": "oudekerk-south-canal-05/b",
              "widthWeight": 1,
              "ordinal": 59
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-06",
          "widthWeight": 1.0,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2610, 2586],
          "plots": [
            {
              "id": "oudekerk-south-canal-06/a",
              "widthWeight": 1,
              "ordinal": 60
            },
            {
              "id": "oudekerk-south-canal-06/b",
              "widthWeight": 1,
              "ordinal": 61
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-07",
          "widthWeight": 1.0,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2626, 2613],
          "plots": [
            {
              "id": "oudekerk-south-canal-07/a",
              "widthWeight": 1,
              "ordinal": 62
            },
            {
              "id": "oudekerk-south-canal-07/b",
              "widthWeight": 1,
              "ordinal": 63
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-08",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2640, 2637],
          "plots": [
            {
              "id": "oudekerk-south-canal-08/a",
              "widthWeight": 1,
              "ordinal": 64
            },
            {
              "id": "oudekerk-south-canal-08/b",
              "widthWeight": 1,
              "ordinal": 65
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-09",
          "widthWeight": 1.0,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2654, 2663],
          "plots": [
            {
              "id": "oudekerk-south-canal-09/a",
              "widthWeight": 1,
              "ordinal": 66
            },
            {
              "id": "oudekerk-south-canal-09/b",
              "widthWeight": 1,
              "ordinal": 67
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-10",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2667, 2686],
          "plots": [
            {
              "id": "oudekerk-south-canal-10/a",
              "widthWeight": 1,
              "ordinal": 68
            },
            {
              "id": "oudekerk-south-canal-10/b",
              "widthWeight": 1,
              "ordinal": 69
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-11",
          "widthWeight": 1.05,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2685, 2710],
          "plots": [
            {
              "id": "oudekerk-south-canal-11/a",
              "widthWeight": 1,
              "ordinal": 70
            },
            {
              "id": "oudekerk-south-canal-11/b",
              "widthWeight": 1,
              "ordinal": 71
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-12",
          "widthWeight": 1.0,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2701, 2735],
          "plots": [
            {
              "id": "oudekerk-south-canal-12/a",
              "widthWeight": 1,
              "ordinal": 72
            },
            {
              "id": "oudekerk-south-canal-12/b",
              "widthWeight": 1,
              "ordinal": 73
            }
          ]
        },
        {
          "id": "oudekerk-south-canal-13",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2724, 2755],
          "plots": [
            {
              "id": "oudekerk-south-canal-13/a",
              "widthWeight": 1,
              "ordinal": 74
            },
            {
              "id": "oudekerk-south-canal-13/b",
              "widthWeight": 1,
              "ordinal": 75
            }
          ]
        }
      ]
    }
  ]
}
